<script setup>
import { ref, watch } from 'vue';
import FordButton from '@/components/FordButton.vue';
import { useToast } from 'vue-toastification';
import CInput from './CInput.vue';
import EventSection from './EventSection.vue';
import statusCodes from './statusCodes';

const props = defineProps({
  event: Object,
  statuses: Object,
  isExpiredLink: Boolean,
});

const emit = defineEmits(['send-code']);

const email = ref('');

const submitEmail = () => emit('send-code', email.value);

const toast = useToast();

if (props.isExpiredLink) {
  toast.error('Expired link. Please just follow the prompts.', { timeout: 10000 });
}

// show error validation toast
watch(
  () => props.statuses.sendCodeStatus,
  (obj) => {
    if (obj === statusCodes.failed) {
      toast.error(
        'We could not send your validation code at this time. Please try again later',
        { timeout: 10000 },
      );
    }
  },
  { deep: true },
);
</script>
<template>
  <div class="tablet:text-center">
    <form @submit.prevent="submitEmail">
      <h1 class="
        text-[1.125rem] tablet:text-[2.125rem]
        font-FordAntennaMed
        mb-[1.875rem]
        max-w-[53rem]
        mx-auto
      ">
        Welcome to the Ford Pro™ Events appointment scheduler. Let's get you logged in!
      </h1>
      <p
        class="
          text-[.875rem] tablet:text-[1rem]
          text-ford-gray-darker
          mb-[1.875rem]
        ">
        We will send you a one-use code to validate your email address.</p>
      <c-input
        class="max-w-[45.5rem] mx-auto"
        aria-label="Email address"
        type="email"
        v-model="email"
        placeholder="Email"
        required />
      <ford-button
        v-if="statuses.sendCodeStatus === statusCodes.loading"
        class="
          mb-[3rem]
        "
        :prevent-default="false"
        disabled>Sending Code...</ford-button>
      <ford-button
        v-else
        class="
          mb-[3rem]
        "
        :prevent-default="false"
        >Send Code</ford-button>
    </form>
    <hr class="
      mx-auto
      max-w-[50rem]
      mb-[2.5rem] hidden tablet:block
    " />
    <event-section :event="event" />
  </div>
</template>
